<template>
	<div class="container">
		<div class="my-5 text-center">
			<b-spinner/>
		</div>
		<Flash ref="show"/>
	</div>
</template>

<script>
	import axios from "axios";
	import Flash from "../components/Flash";
	import {api} from "../mixins/axios";

	export default {
		name: "Login",
		components: {
			Flash,
		},
		data() {
			return {};
		},
		methods: {
			async login() {
				let requestOptions = {
					login_token: this.$route.query.login_token,
				};
				localStorage.setItem('accessToken', this.$route.query.login_token);
				await api.put(
					`/users/login_token_to_auth_token`,
					requestOptions
				).then(response => {
					if (response.data.status == 'ok') {
						localStorage.setItem('accessToken', response.data.token.token);

						setTimeout(() => {
							location.href = "/"
						}, 2000)
					}
				}).catch(e => {
						this.$refs.show.showFlashError(e.response.data.msg)
						setTimeout(() => {
							localStorage.clear();
							location.href = "/"
						}, 2000)
					}
				)
			}

		},
		mounted() {
			this.login()
		},
	};
</script>

<style scoped lang="scss">

</style>
